/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getCompanyContactBook } from "api/services/company";
import { GetCompanyContactBookRequestParams } from "api/request/company.request";
import {
  mapContactBookResults,
  ContactBookOption,
} from "pages/shipper/RequestFormV2/sections/Schedule/utils/contactBook";
import { companyQueryKeys } from "./companyQueryKeys";

export type GetCompanyContactBookQueryParams = GetCompanyContactBookRequestParams & {
  stopIndex?: number;
};

export function useGetCompanyContactBook(
  params: GetCompanyContactBookQueryParams,
  options?: UseQueryOptions<ContactBookOption[], unknown, ContactBookOption[]>,
) {
  const { stopIndex: _stopIndex, ...apiParams } = params;

  return useQuery<ContactBookOption[]>({
    queryKey: [...companyQueryKeys.contactBook(params), apiParams],
    queryFn: () =>
      getCompanyContactBook({ params: apiParams }).then((res) => mapContactBookResults(res.data.results ?? [])),
    enabled: !!apiParams.location,
    ...options,
  });
}
